export function Footer() {
    return (
        <section id="footer">
            <div className="copyright">
                <ul className="menu">
                <li>&copy; Daniel E. de la Rosa. All rights reserved.</li><li>Design: <a href="https://alexportaf.herokuapp.com/" target="_blank" rel="noreferrer">Alexander Polanco</a></li>                </ul>
            </div>
        </section>
    );
};